import { render, staticRenderFns } from "./PlanDetailsPage.vue?vue&type=template&id=aaf5f244&scoped=true"
import script from "./PlanDetailsPage.vue?vue&type=script&lang=ts"
export * from "./PlanDetailsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf5f244",
  null
  
)

export default component.exports